import _ from 'lodash';

const systemPartnerId = 1;

const channels = {
  SMS: 1,
  Email: 2,
  Inbox: 3,
  PushNotification: 4,
  WhatsApp: 6,
};

const messageCategories = {
  Promotion: 2,
  Newsletter: 3,
  Notification: 4,
  Bonus: 5,
  Other: 1,
};

const notificationPreferences = {
  Deposit: 1,
  Withdrawal: 2,
  Promotion: 4,
  Bonuses: 8,
};

const notificationTypes = {
  Sms: 1,
  Email: 2,
  PushNotification: 4,
};

const playerStatuses = {
  Active: 1,
  Blocked: 2,
  BlockedForSport: 4,
  BlockedForCasino: 8,
  BlockedForWithdrawals: 16,
  BlockedForDeposits: 64,
  BlockedForUnverified: 128,
};

const playerBlockedStatuses = _.pickBy(playerStatuses, (val) => [
  playerStatuses.Blocked,
  playerStatuses.BlockedForSport,
  playerStatuses.BlockedForCasino,
  playerStatuses.BlockedForWithdrawals,
  playerStatuses.BlockedForDeposits,
  playerStatuses.BlockedForUnverified,
].includes(val));

const templateStatus = {
  Ready: 0,
  Draft: 1,
};

const massMessageStatuses = {
  Sent: 3,
  Failed: 4,
  Sending: 6,
};

const genders = {
  Male: 1,
  Female: 2,
  PreferNotSay: 4,
  Other: 8,
};

const marketingStatuses = {
  New: 1,
  Common: 2,
  Active: 3,
  Dormant: 4,
  Deactivated: 5,
  Returned: 6,
  Churn: 7,
};

const domainStatuses = {
  Active: 0,
  Pending: 1,
  InActive: 4,
};

const bonuses = {
  Casino: 1,
  Sport: 2,
  Special: 3,
  Spin: 4,
};

const allBonusTypes = {
  FreeBet: 101,
  WagerStandard: 102,
  WagerReal: 103,

  SportWagering: 200,
  SportFreeBet: 201,
  SportRealWagering: 202,

  RealMoney: 300,

  FreeSpin: 400,
  FreeAmount: 401,
};

const bonusStatuses = {
  Scheduled: 0,
  Active: 1,
  Canceled: 2,
  PromotionCanceled: 3,
  Finished: 4,
  PartialCancelled: 5,
  Pending: 6,
  InProcess: 7,
};

const campaignV2Statuses = {
  Draft: 0,
  Scheduled: 1,
  Active: 2,
  // Canceled: 3,
  // PromotionCanceled: 4,
  Finished: 5,
  // PartialCancelled: 6,
  Pending: 7,
  InProcess: 8,
};

const playerBonusStatuses = {
  New: 1,
  Active: 2,
  Finished: 3,
  Canceled: 4,
  Expired: 5,
  Pending: 6,
  Paused: 7,
};

const periods = {
  Daily: 0,
  Weekly: 1,
  Monthly: 2,
};

const promoCodeTypes = {
  Single: 0,
  Multiple: 1,
  External: 2,
};

const markAttentionLevels = {
  None: 0,
  Standard: 1,
  High: 2,
  Critical: 3,
};

const playerActions = {
  EndSession: 0,
  BlockSportsbook: 1,
  BlockCasino: 2,
  BlockWithdrawals: 4,
  BlockAccount: 5,
  BlockMessages: 6,
  Unblock: 7,
  MarkAttention: 8,
  RemoveAttention: 9,
  Unlock: 10,
  AccountClosure: 11,
  Inactive: 12,
  Activate: 13,
  Lock: 14,
  Blacklist: 15,
  Whitelist: 16,
  BlockDeposits: 19,

  UnblockWithdrawals: 17,
  UnblockDeposits: 18,
  UnblockMessages: 20,
  DisableLogin2FA: 21,
  EnableLogin2FA: 22,
  BlockUnverify: 23,
  UnblockUnverify: 24,
  SetOTP: 25,

  UnblockSportsbook: 1000,
  UnblockCasino: 1001,
  UnblockAccount: 1003,
  VerifyEmail: 1004,
  UnVerifyEmail: 1005,
  VerifyIdentity: 1006,
  UnVerifyIdentity: 1007,
  VerifyMobile: 1008,
  UnVerifyMobile: 1009,
  VerifyAddress: 1010,
  UnVerifyAddress: 1011,
  CompletePhysicalVerification: 1012,
  IncompletePhysicalVerification: 1013,
  VerifyCitizenship: 1014,
  UnVerifyCitizenship: 1015,
  BlockActivities: 1016,
  UnblockActivities: 1017,
};

const walletType = {
  Rollover: 1,
  Unused: 2,
  Used: 3,
  Bonus: 4,
  Booked: 5,
  Debt: 6,
  SportBonus: 90,
};

const providerSpecificType = {
  SportBooks: 1,
  Casino: 2,
};

const playerVerification = {
  Email: 1,
  Mobile: 2,
  Address: 4,
  Identity: 8,
  Physical: 16,
  Citizenship: 32,
  Payment: 128,
  Edd: 256,
};

const cashBackType = {
  Fixed: 1,
  Dynamic: 2,
  Series: 3,
};

const cashbackTransferType = {
  Manual: 2,
  Automatic: 1,
};

const captchaType = {
  Digitain: 1,
  Google2: 2,
  CloudflareTurnstile: 4,
};

const bonusCommonStatuses = {
  Scheduled: 1,
  Active: 2,
  Disabled: 3,
  Finished: 4,
};

const cashBackReferralPeriodStatus = {
  Accumulated: 1,
  Transferred: 2,
  Failed: 3,
};

const brandStatuses = {
  Active: 1,
  Disabled: 2,
  ActivitiesDisabled: 3,
  VersionNamesDisabled: 4,
  Maintenance: 5,
};

const testPlayerAccountType = {
  Temporary: 1,
  Permanent: 2,
};

const similarAccountDetectionArea = {
  Session: 1,
  Registration: 2,
};

const similarAccountParameterType = {
  Ip: 1,
  DeviceId: 2,
  BrowserFamily: 3,
};

const referralFinancialActivity = {
  Deposits: 0,
  Bets: 1,
  GGR: 2,
  NGR: 3,
};

const referralReferees = {
  All: 1,
  New: 2,
};

const referralBonusType = {
  Dynamic: 1,
  Progressive: 2,
  Prize: 3,
};

const referralBonusAmount = {
  PerReferee: 0,
  AllReferees: 1,
};

const referralActivities = {
  SignUp: 0,
  Verification: 1,
  Deposit: 2,
  Bet: 3,
};

const selfExclusionPeriods = {
  None: 0,
  Months2: 1,
  Months3: 2,
  Months6: 3,
  Months8: 4,
  Year1: 5,
  Years2: 6,
  Years5: 7,
  Years3: 8,
  Week1: 9,
  Months1: 10,
  Indefinite: 100,
};

const exclusionPerformedByTypes = {
  Admin: 0,
  Player: 1,
  System: 2,
};

const playerReasons = {
  ActionControl: 1,
  AccountClosure: 4,
  DepositLimit: 8,
  BetLimit: 16,
  WithdrawalLimit: 32,
  SelfExclusion: 64,
  Timeout: 128,
};

const timeoutPeriod = {
  None: 0,
  Day1: 1,
  Days2: 2,
  Days3: 3,
  Days4: 4,
  Days5: 5,
  Days6: 6,
  Week1: 7,
  Weeks2: 8,
  Weeks3: 9,
  Month1: 10,
  Weeks6: 11,
};

const limitPeriod = {
  Day1: 0,
  Days7: 1,
  Month1: 2,
  Year1: 3,
  Days3: 4,
};

const limitationTypes = {
  SelfExclusion: 0,
  Timeout: 1,
  Deposit: 2,
  Withdrawal: 3,
  Bet: 4,
  RealityCheck: 5,
  AccessLimit: 6,
  LossLimit: 7,
  SingleBet: 8,
  GameTimeLimit: 9,
  NetDeposit: 10,
};

const sportBonusBetType = {
  Single: 2,
  Multi: 3,
  Express: 1,
};

const expressOddType = {
  Total: 1,
  Minimum: 2,
};

const requestMethods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

const paymentRequestStatuses = {
  Initialized: 0,
  Pending: 1,
  InProcess: 2,
  CancelledByUser: 3,
  CancelledByPlayer: 4,
  Failed: 5,
  Declined: 7,
  Frozen: 8,
  PayPending: 9,
  Paid: 10,
  OnHold: 11,
};

const betStates = {
  New: 1,
  Won: 2,
  Lost: 3,
  Cancelled: 4,
  CashOut: 5,
};

const largeTransactionTypes = {
  Deposit: 1,
  Bet: 2,
  Win: 3,
  Withdrawal: 4,
  Other: 5,
};

const playerLimitPeriodTypes = {
  Periodic: 1,
  UpcomingPeriod: 2,
  TriggerLastPeriod: 3,
};

const timeLimitPerformedByTypes = _.pick(exclusionPerformedByTypes, ['Admin', 'Player']);

const playerLimitsPeriods = {
  Immediately: 0,
  Daily: 4,
  Weekly: 5,
  Monthly: 6,
  Custom: 7,
};

const paymentTransactionTypes = {
  Deposit: 1,
  Withdrawal: 2,
  All: 3,
};

const playerPaymentRelations = {
  AllPaymentMethods: 1,
  UnusedPaymentMethods: 2,
};

const legalAgreementVersionStatuses = {
  Pending: 1,
  Current: 2,
  Old: 3,
};

const brandVerificationDocumentTypes = {
  Passport: 'passport',
  IdCard: 'idCard',
  DrivingLicense: 'drivingLicense',
  Selfie: 'selfie',
  BankCard: 'bankCard',
  UtilityBills: 'utilityBills',
  TaxBills: 'taxBills',
  BankStatement: 'bankStatement',
  RentAgreement: 'rentAgreement',
  InsuranceAgreement: 'insuranceAgreement',
  ResidencyCard: 'residencyCard',
  PaymentMethod: 'paymentMethod',
  IncomeFromEmployment: 'incomeFromEmployment',
  IncomeFromInvestments: 'incomeFromInvestments',
  IncomeFromSales: 'incomeFromSales',
  ProofOfInheritance: 'proofOfInheritance',
  SpecialPermitOfStay: 'specialPermitOfStay',
  TemporaryProtectionPermit: 'temporaryProtectionPermit',
  Other: 'other',
};

const paymentType = {
  Online: 0,
  Terminal: 1,
  Offline: 2,
  Agent: 3,
};

const paymentActivities = {
  Both: 0,
  Deposit: 1,
  Withdrawal: 2,
};

const processingTypes = {
  ReceiptConfirmTerminal: 1,
  ReceiptConfirmWeb: 2,
  DepositUpdateOneStep: 3,
  DepositUpdateTwoStep: 4,
  StandardWithdrawal: 5,
  StandardWithdrawalWithCheckPayeeData: 6,
  TwoStepWithdrawal: 7,
  TwoStepWithdrawalInstantRedirection: 8,
};

const paymentMethodsFeesTypes = {
  OperatorDepositFee: 1,
  OperatorWithdrawalFee: 2,
  OperatorWithdrawalFeeForUsed: 3,
};

const paymentMethodLimitTypes = {
  MinDepositAmount: 1,
  MaxDepositAmount: 2,
  MinWithdrawalAmount: 3,
  MaxWithdrawalAmount: 4,
};

const paymentMethodActionTypes = {
  Block: 1,
  Unblock: 2,
};

const paymentProcessingOption = {
  None: 1,
  Immediately: 2,
  Custom: 3,
};

const paymentProcessingRangeUnit = {
  Minute: 1,
  Hour: 2,
};

const cashierOtherId = 0;

const tagNoCategoryId = 99999;

const cashierPaymentSettings = {
  DepositLimits: 1,
  DepositFee: 2,
  MinMaxDepositAmount: 4,
  DepositFeeCalculator: 8,
  PlayerWithdrawalLimit: 16,
  UnusedBalanceWithdrawalFee: 32,
  UsedBalanceWithdrawalFee: 64,
  MinMaxWithdrawalAmount: 128,
  WithdrawableAmount: 256,
  WithdrawalFeeCalculator: 512,
};

const cashbackCalculationFrom = {
  FromBets: 1,
  FromNetDeposits: 2,
};

const cashbackParticipateRules = {
  ExcludePlayersNegativeLifetimeNet: 1,
  IncludeBonusRedeems: 2,
  IncludeRealMoneyBonuses: 4,
};

const cashbackV2ParticipateRules = {
  ExcludePlayersNegativeLifetimeNet: 1,
  IncludeBonusRedeems: 2,
  IncludeRealMoneyBonuses: 4,
};

const allDeviceTypes = {
  Unknown: 1,
  Betshop: 2,
  WebDesktop: 4,
  WebMobile: 8,
  Wap: 16,
  Terminal: 32,
  Android: 64,
  Ios: 128,
  POS: 256,
  LiteBet: 512,
  WebOldMobile: 1024,
  PwaApp: 2048,
  TV: 8192,
};

const deviceTypes = {
  Other: 1,
  WebDesktop: 4,
  WebMobile: 8,
  Android: 64,
  Ios: 128,
  PwaApp: 2048,
  TV: 8192,
};

const selectedPlayersErrorStatus = {
  TimeOut: 1,
  InvalidKey: 2,
  MissingCurrency: 4,
  SelfExcluded: 8,
  Blocked: 16,
  BlockedInSport: 64,
  BlockedInCasino: 128,
  Deleted: 256,
  BlockForDeposit: 512,
  BlockForWithdrawal: 1024,
  BlockForUnverified: 2048,
};

const quickSearchResponseItemType = {
  Player: 1,
  Deposit: 2,
  Withdrawal: 3,
  SportBet: 4,
  CasinoBet: 5,
};

const walletTransactionTypes = {
  Sport: 0,
  Casino: 1,
  Deposit: 2,
  Withdrawal: 3,
  BalanceAdjustment: 4,
  CashBack: 5,
  SportBonus: 6,
  CasinoBonus: 7,
  SpecialBonus: 8,
};

const lobbyWidgetGridTypes = {
  Standard: 1,
  Advanced: 2,
  Vertical: 3,
  Horizontal: 4,
};

const betTypes = {
  Casino: 1,
  Sport: 2,
};

const logicTypes = {
  Real: 1,
  Bonus: 2,
};

const gameOrderTypes = {
  GGR: 1,
  PlayedRounds: 2,
  Likes: 3,
  Name: 4,
  CreationDate: 5,
  DistinctPlayerCount: 6,
  Favorites: 7,
  CustomOrdering: 8,
};

const playerContactInfoVerificationTypes = {
  Email: 1,
  Mobile: 2,
};

const playerPhysicalVerificationTypes = {
  Address: 1,
  Identity: 2,
  Physical: 3,
  Citizenship: 4,
  Edd: 5,
};

const sportPlayerStatus = {
  Common: 1,
  New: 2,
  Female: 3,
  VipUser: 4,
  Terminal: 5,
  Arbitage: 6,
  Problem: 7,
  Special: 8,
  Marker: 9,
  TradingAnalysing: 10,
  LateBetting: 11,
  Middler: 12,
  Betshop: 13,
  Professional: 14,
  HighValue: 15,
  VipSpecial: 16,
  BonusHunter: 17,
  Capper: 18,
  Inactive: 19,
  LowGgr: 20,
  VipPlatinum: 21,
  GoodGuys: 25,
  VipBronze: 26,
  VipSilver: 27,
  VipGold: 28,
  VipUltra: 29,
};

const boolean = {
  No: 0,
  Yes: 1,
};

const sessionEndReason = {
  Logout: 1,
  OtherSessionCreate: 2,
  TimeOut: 3,
  Blocked: 4,
  Closed: 5,
};

const brandAutomationOperator = {
  In: 1,
  NotIn: 2,
  Equals: 3,
  Greater: 4,
  Less: 5,
  GreaterOrEqual: 6,
  LessOrEqual: 7,
  Between: 8,
  All: 9,
  Any: 10,
  NotAny: 11,
};

const brandAutomationConditionPeriodType = {
  OneHour: 1,
  SixHours: 2,
  TwelveHours: 3,
  OneDay: 4,
  SevenDays: 5,
  ThirtyDays: 6,
  TwoMonths: 7,
  Lifetime: 8,
  LastOneHour: 10,
  LastSixHours: 20,
  LastTwelveHours: 30,
  LastOneDay: 40,
  LastSevenDays: 50,
  LastThirtyDays: 60,
  LastTwoMonths: 70,
  LastSixMonths: 80,
};

// reasons Resources
const resource = {
  BlockProviders: 1,
  AccountClosure: 2,
  BalanceAdjustment: 3,
  GameManagement: 4,
  PlayerAccountMarkAttention: 6,
  PlayersBetLimitation: 7,
  PlayersDepositLimitation: 8,
  PlayersStatusUpdate: 9,
  PlayersTimeOut: 10,
  PlayersWithdrawals: 11,
  VerticalTags: 12,
  PlayersSelfExclusion: 13,
  WithdrawalsStatusChange: 14,
  PlayersBlockControl: 16,
  PlayersLossLimitation: 18,
  PlayersSingleBetLimitation: 19,
  BlockPaymentMethods: 20,
  ExchangeMaterialPrize: 21,
  WebsiteSelfExclusion: 22,
  WebsiteAccountTimeOut: 23,
  PlayersGameTimeLimitation: 24,
};

const reasonsType = {
  Default: 1,
  Custom: 2,
  System: 3,
};

const campaignTriggerTypes = {
  NoTrigger: 0,
  SignUp: 1,
  Verify: 2,
  Deposit: 3,
  SignIn: 5,
};

const campaignParticipantTypes = {
  AllPlayers: 0,
  Players: 1,
  PlayersWithAmount: 2,
  PromoCode: 3,
  Join: 4,
};

const bonusCountTypes = {
  Single: 1,
  Multi: 2,
};

const campaignTriggerPeriodTypes = {
  Every: 1,
  Daily: 2,
  Lifetime: 3,
};

const campaignTriggerOption = {
  Every: 1,
  NumberOf: 2,
};

const campaignConditionTypes = {
  Country: 1,
  Payments: 2,
  Verify: 3,
  WeekDays: 4,
  AccountStatus: 5,
  SportStatus: 6,
  Segment: 7,
  Tag: 8,
  TriggerDeviceType: 9,
  SignUpDeviceType: 10,
  MonthlyDates: 11,
};

const weekDays = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7,
};

const campaignOperators = {
  In: 1,
  NotIn: 2,
  All: 3,
};

const tagCategoryType = {
  Horizontal: 1,
  Vertical: 2,
};

const politicallyExposedPerson = {
  None: 0,
  Domestic: 1,
  Foreign: 2,
  International: 3,
};

const sportsBookMobileIntegrationType = {
  Iframe: 1,
  Native: 2,
};

const sportsBookLayoutTypes = {
  Standard: 1,
  African: 2,
  Latin: 3,
  Asian: 4,
  Modern: 7,
};

const realityCheckRepetitionPeriod = {
  None: 0,
  Minutes10: 1,
  Minutes20: 2,
  Minutes30: 3,
  Minutes40: 4,
  Minutes50: 5,
  Hours1: 6,
  Hours2: 7,
  Hours3: 8,
  Hours4: 9,
  Hours5: 10,
  Hours6: 11,
  Minutes15: 13,
  Minutes45: 14,
};

const affiliateTypes = {
  Everymatrix: 1,
  Smartico: 2,
  Digitain: 3,
  Alanbase: 4,
  MyAffiliates: 5,
  IncomeAccess: 6,
};

const analyticTypes = {
  Hotjar: 1,
  GoogleAnalytics: 2,
  GoogleSearchConsole: 3,
  GoogleAds: 4,
};

const liveChatSolutionTypes = {
  LiveChat: 1,
  LiveAgent: 2,
  Zendesk: 3,
  Intercom: 4,
  WhatsApp: 5,
};

const crmTypes = {
  Smartico: 1,
  Digitain: 2,
  Optimove: 3,
};

const gamificationTypes = {
  Smartico: 1,
  ThunderBite: 2,
};

const authenticationTypes = {
  Firebase: 1,
  ItsMe: 2,
  Authentigate: 3,
  Trustly: 4,
};

const retailSolutionTypes = {
  Digitain: 1,
};

const userClaimTypes = {
  SuperAdmin: 1,
  Developer: 3,
};

const campaignUseTypes = {
  Common: 1,
  CrossPlatform: 2,
};

const campaignV2UseTypes = {
  Common: 1,
  CrossPlatform: 2,
};

const lobbyGridTypes = {
  Standard: 1,
  Advanced: 2,
  Special: 3,
  Vertical: 4,
};

const lobbyFilterTypes = {
  Theme: 1,
  StakeRange: 2,
  Features: 4,
  Volatility: 8,
};

const lobbyGamesViewTypes = {
  GameDetailsPreview: 1,
  GameDetailsCard: 2,
};

const lobbyProvidersPositions = {
  ExtendedTab: 1,
  Slider: 2,
  DropDown: 3,
};

const lobbyViewTypes = {
  Text: 1,
  Icon: 2,
};

const lobbyProvidersViewTypes = {
  Text: 1,
  Logo: 2,
};

const lobbyGroupsViewTypes = {
  Text: 1,
  Icon: 2,
};

const lobbyGameDetailsOnHoverTypes = {
  GameName: 1,
  ProviderName: 2,
};

const brandVerificationPeriod = {
  FirstDepositDate: 0,
  RegistrationDate: 1,
};

const maxExpressOddTypes = {
  Total: 1,
  Maximum: 3,
};

const promotionalItemType = {
  Promotion: 1,
  Campaign: 2,
};

const promotionalItemStatus = {
  Active: 1,
  Finished: 2,
};

const rgsDeviceIds = {
  All: 4,
  Desktop: 5,
  Mobile: 6,
};

const exportReportStates = {
  InQueue: 1,
  Generating: 2,
  Generated: 3,
  Expired: 4,
  Cancelled: 5,
  Failed: 6,
};

const bonusCancellerTypes = {
  System: 1,
  Player: 2,
  User: 3,
};

const bonusActivationTypes = {
  Player: 1,
  System: 2,
};

const devToolDbSyncMergeModes = {
  Delta: 0,
  Full: 1,
  InsertsAndUpdates: 2,
  InsertsOnly: 3,
  UpdatesOnly: 4,
};

const pushNotificationRecipients = {
  Active: 1,
  Guest: 2,
  All: 3,
};

const pushNotificationStatuses = {
  Sent: 3,
  Failed: 4,
  Scheduled: 5,
  Sending: 6,
  Preparing: 7,
};

const playerPushNotificationStatuses = {
  Failed: 1,
  Scheduled: 2,
  Sent: 3,
  Read: 4,
  Expired: 5,
};

const permissionSecurityLevel = {
  Lowest: 1,
  Low: 2,
  Medium: 3,
  High: 4,
  Higher: 5,
  VeryHigh: 6,
  Maximum: 7,
};

const campaignSourceTypes = {
  Internal: 1,
  Sport: 2,
};

const deepLinkSections = {
  Login: 1,
  Registration: 2,
  MyProfile: 3,
  Deposit: 4,
  Withdrawal: 5,
  Casino: 6,
  Sport: 7,
  InboxMessages: 8,
  Verification: 9,
  OffersSport: 10,
  OffersCasino: 11,
  PromoCodes: 12,
  Tournament: 13,
  EventId: 14,
  CasinoProvider: 15,
  LiveCasinoProvider: 16,
  TVGames: 17,
  VirtualSport: 18,
  CasinoGame: 19,
  CustomPage: 20,
  SportsPrematch: 21,
  SportsLive: 22,
  EsportMain: 23,
  BetRace: 24,
  CasinoLobbyGamesGroup: 25,
  LiveCasinoLobbyGamesGroup: 26,
  TVGamesLobbyGamesGroup: 27,
  FastGamesLobbyGamesGroup: 28,
  VirtualSportLobbyGamesGroup: 29,
  LiveCasinoGame: 30,
  TVGamesGame: 31,
  VirtualSportGame: 32,
  FastGamesGame: 33,
  Gamification: 34,
};

const playerAccessLimitTypes = {
  None: 1,
  Repetitive: 2,
  SpecificDate: 3,
};

const inactivityTriggerTypes = {
  None: 0,
  Login: 1,
  Transaction: 2,
};

const inactivePeriodMonths = {
  Months3: 3,
  Months6: 6,
  Months12: 12,
  Months24: 24,
};

const failedBonusReasons = {
  BlockedAccount: 1,
  BlockedForTransactions: 2,
  BlockedForSport: 3,
  BlockedForCasino: 4,
  BlockedForDeposit: 5,
  BlockedForWithdrawals: 6,
  CurrencyMismatch: 7,
  Country: 8,
  TriggerDeviceType: 9,
  Verification: 10,
  AccountStatus: 11,
  SportStatus: 12,
  Segment: 13,
  Tag: 14,
  DepositNumber: 15,
  MinDepositAmount: 16,
  MaxTriggerCount: 17,
  MaxTriggerCountDaily: 18,
  Weekdays: 19,
  SignUpDeviceType: 20,
  DisconnectTrigger: 21,
  Payments: 22,
  AlreadyReceived: 23,
  NumberOf: 24,
  NumberOfFinal: 25,
  NumberOfDailyFinal: 26,
};

const tagAction = {
  Add: 1,
  Update: 2,
  Delete: 3,
  Enable: 4,
  Disable: 5,
  Merge: 6,
  Move: 7,
  Tagged: 8,
  Untagged: 9,
};

const gamesMobileLaunchTypes = {
  FullScreen: 0,
  HeaderFooter: 1,
  QuickActionsBar: 2,
};

const freeGameWinType = {
  GrossWin: 1,
  PureWin: 2,
};

const inactivePlayerMoneyTransferTypes = {
  None: 1,
  Government: 2,
  Player: 3,
};

const inactivePlayerCredentialsProvidedTypes = {
  None: 0,
  Provided: 1,
  NonProvided: 2,
};

const releaseNoteLabels = {
  Bug: 1,
  Improvement: 2,
  Feature: 3,
};

const crossCampaignSourceTypes = {
  // Smartico: 1,
  Gamification: 2,
  // PushNotification: 3,
  // CRM: 4,
  // Betera: 5,
  // Thunderbyte: 6,
  Campaign: 7,
};

const crossCampaignSourceStatuses = {
  Active: 1,
  Finished: 2,
};

const thirdPartyServicesStatuses = {
  NotIntegrated: 0,
  Enabled: 1,
  Disabled: 2,
};

const jackpotFeedTypes = {
  Single: 1,
  Multi: 2,
};

const campaignV2ParticipantTypes = {
  AllPlayers: 0,
  Players: 1,
  PlayersWithAmount: 2,
  PromoCode: 3,
};

const campaignV2ParticipantConditionTypes = {
  Country: 1,
  Verify: 2,
  AccountStatus: 3,
  SportStatus: 4,
  Segment: 5,
  Tag: 6,
  TriggerDeviceType: 7,
  SignUpDeviceType: 8,
  RegistrationDate: 9,
  Btag: 10,
  Gender: 11,
};

const campaignV2Operators = {
  In: 1,
  NotIn: 2,
  All: 3,
};

const campaignV2TriggerTypes = {
  NoTrigger: 0,
  SignUp: 1,
  Verify: 2,
  Deposit: 3,
  SignIn: 4,
  Bet: 5,
  GameLaunch: 6,
  Withdrawal: 7,
  AutoDepositActivation: 8,
};

const campaignV2PromoCodeTypes = {
  Single: 0,
  Multiple: 1,
  External: 2,
};

const campaignV2BonusFamilies = {
  FreeBet: 1,
  Spin: 2,
  Combined: 3,
  Special: 4,
};

const campaignV2Bonuses = {
  FreeBetCasino: 1,
  FreeBetSport: 2,
  WagerCombined: 3,
  RealMoney: 6,
  FreeGame: 4,
};

const campaignV2MixedBonusSubTypes = {
  FreeSpin: 1,
  FreeAmount: 2,
  CombinationSpin: 4,
  Countdown: 8,
  FreeChip: 16,
};

const campaignV2GameTypes = {
  All: 1,
  Custom: 2,
  Segments: 3,
};

const referralParticipationTypes = {
  AllPlayers: 1,
  CustomSelection: 2,
};

const campaignV2RgsDeviceIds = {
  All: 4,
  Desktop: 5,
  Mobile: 6,
};

const campaignV2TriggerConditionTypes = {
  Recurring: 1,
  TriggerDeviceType: 2,
  Payments: 3,
  SignUpDeviceType: 4,
  Games: 5,
  CasinoBets: 6,
  SportBets: 7,
};

const campaignV2RecurringTriggerConditionTypes = {
  WeekDays: 1,
  MonthlyDays: 2,
};

const campaignV2SportBonusBetTypes = {
  Single: 1,
  Multi: 2,
  SingleAndMulti: 3,
};

const campaignV2WageringAmountTypes = {
  Trigger: 1,
  Bonus: 2,
  Both: 3,
};

const campaignV2WageringParticipationTypes = {
  Bonus: 1,
  Real: 2,
  Both: 3,
};

const campaignV2FirstDebitedWalletTypes = {
  Bonus: 1,
  Real: 2,
};

const campaignV2LockAmountTypes = {
  None: 0,
  Trigger: 1,
  Full: 2,
};

const campaignV2TriggerOptions = {
  NumberOf: 1,
  Every: 2,
  Cumulative: 3,
  Multiplier: 4,
};

const campaignV2TriggerOptionPeriods = {
  Current: 1,
  Daily: 2,
  LifeTime: 3,
  Weekly: 4,
  Monthly: 5,
};

const massMessageSourceTypes = {
  Internal: 1,
  DigitainCrm: 2,
  External: 3,
};

const campaignV2BonusCancellerTypes = {
  Player: 1,
  System: 2,
  User: 3,
};

const playerBlockActions = {
  SportBooks: 1,
  Casino: 2,
  Withdrawals: 4,
  Deposit: 8,
  Messages: 32,
  Account: 64,
  Unverified: 128,
};

const campaignV2FreeSpinWinTypes = {
  RealMoney: 1,
  Bonus: 2,
};

const jackpotSetStatuses = {
  Active: 1,
  Inactive: 2,
  Deleted: 3,
};

const widgetGameSelectionTypes = {
  GameUpload: 1,
  GroupSelection: 2,
  Custom: 3,
};

const campaignV2BetContributionTypes = {
  Real: 1,
  RealBonus: 2,
};

const regulatoryExclusionTypes = {
  Exclusion: 1,
  SelfExclusion: 2,
};

const regulatoryExclusionChannels = {
  Other: 0,
  Licensee: 1,
  HGC: 2,
};

const regulatoryExclusionDurationCategories = {
  Other: 0,
  Indefinite: 1,
  Temporary: 2,
  Hours24: 3,
};

const sportTreeRuleInvolvements = {
  Include: 1,
  Exclude: 2,
};

const cashbackV2CalculationFrom = {
  Bets: 3,
  NetDeposits: 4,
};

const cashbackV2WinTypes = {
  RealMoney: 1,
  Bonus: 2,
};

const cashbackV2PrizeTypes = {
  Fixed: 1,
  Percent: 2,
};

const campaignV2SourceTypes = {
  Internal: 1,
  Optimove: 2,
  ThunderBite: 3,
};

const betWalletTypes = {
  Rollover: 1,
  Unused: 2,
  Used: 3,
  Booked: 5,
  Debt: 6,
  FreeBetCasino: 501,
  FreeBetSport: 502,
  SportWager: 503,
  CasinoWager: 504,
  MixWager: 505,
};

const websiteWalletTypes = {
  Used: 1,
  Unused: 2,
  Rollover: 4,
  Withdrawable: 8,
  BonusBalance: 16,
  FreeBetCount: 32,
  FreeSpinCount: 64,
  RealBalance: 128,
};

const regulatoryBetEventCategoriesA = {
  SportsEvents: 1,
  FantasySports: 2,
  VirtualEvents: 3,
  OtherEvents: 4,
};

const regulatoryPlayerLimitCategories = {
  Other: 0,
  DailyTimeLimit: 1,
  WeeklyTimeLimit: 2,
  MonthlyTimeLimit: 3,
  DailyDepositLimit: 4,
  WeeklyDepositLimit: 5,
  MonthlyDepositLimit: 6,
  DailyLossLimit: 7,
  WeeklyLossLimit: 8,
  MonthlyLossLimit: 9,
};

const regulatoryBetEventTypes = {
  Main: 0,
  Secondary: 1,
};

const regulatoryGameCategories = {
  CasinoGamesLiveInStudio: 1,
  CasinoGames: 2,
  Other: 3,
  PeerToPeerGames: 4,
};

const regulatoryBonusCategoryA = {
  RedeemableBonusSchema: 0,
  NonRedeemableBonusSchema: 1,
};

const regulatoryBonusCategoryB = {
  Cashback: 1,
  FreeBet: 2,
  FreeRound: 3,
  KambiFreeBet: 4,
  Standard: 5,
  Tournament: 6,
  TournamentTicket: 7,
  Wagering: 8,
};

const playersBettingAggregationCriteriaTypes = {
  GamingDay: 1,
  BetEventId: 2,
  BetType: 3,
  BetsOver1000Euros: 4,
};

const bettingEventCategories = {
  PreGame: 1,
  Live: 2,
  PreGameAndLive: 3,
};

const bettingPerformanceBetTypes = {
  Single: 1,
  Parlay: 2,
  Multiples: 3,
  Other: 4,
};

const taxationTypes = {
  Cumulative: 1,
  PerTransaction: 2,
  Other: 3,
};

const taxationProductCategories = {
  P2P: 1,
  Slot: 2,
  LiveCasino: 4,
  VirtualSport: 8,
  TableGames: 16,
  Poker: 32,
  TurboGames: 64,
  TVGames: 128,
  FantasySport: 256,
  LotteryGames: 512,
  Other: 1073741824,
};

const campaignV2SportEventTypes = {
  PreMatch: 1,
  Live: 2,
  All: 3,
};

const lobbyWidgetDeviceTypes = {
  Desktop: 3,
  Mobile: 2,
  All: 1,
};

const campaignV2EligibleBetTypes = {
  Placed: 1,
  Settled: 2,
};

const campaignV2EligibleBetStates = _.pickBy(betStates, (val) => [betStates.Won, betStates.Lost].includes(val));

const aggregationCriteriaTypes = {
  Daily: 1,
  Monthly: 2,
};

const campaignV2SportBetBuilderTypes = {
  All: 1,
  OnlyBetBuilder: 2,
  WithoutBetBuilder: 3,
};

const realityCheckCalculationTypes = {
  SessionTime: 1,
  GameplayTime: 2,
};

const campaignV2UnitStatuses = {
  Draft: 0,
  Scheduled: 1,
  Active: 2,
  PartialCancelled: 3,
  Canceled: 4,
  Finished: 5,
};

const legalAgreementStates = {
  Declined: 0,
  Approved: 1,
};

const blockCountryTypes = {
  Unblocked: 0,
  Fully: 1,
  Login: 2,
  Registration: 3,
  LoginAndRegistration: 4,
  Deposit: 5,
  RegistrationAndDeposit: 6,
  FullyBlockedVpnAllowed: 7,
};

const eddVerificationOptions = {
  NotRequired: 1,
  Required: 2,
  Pending: 3,
  Unverified: 4,
  Verified: 5,
};

const selectionTypes = {
  CustomSelection: 1,
  Upload: 2,
};

const digitainAffiliateDataSendPeriodTypes = {
  Hourly: 1,
  Daily: 2,
};

const lobbyDemoButtonOnGamesDeviceTypes = {
  Mobile: 1,
  Desktop: 2,
};

const exportTypes = {
  Csv: 1,
  Excel: 2,
  Summary: 3,
};

const liabilityWalletTypes = {
  RealMoney: 0,
  BonusMoney: 1,
};

const liabilityTypes = {
  PendingWithdrawals: 0,
  FinalizedWithdrawals: 1,
  Balance: 2,
  CasinoOpenBet: 3,
  SportOpenBet: 4,
  RealBalance: 5,
  BonusBalance: 6,
};

const providerActionTypes = {
  Block: 1,
  Unblock: 2,
};

const transactionsHistoryTypes = {
  BalanceAdjustment: 0,
  ReferrerHistory: 1,
  Cashback: 2,
  SportJackpot: 3,
  Bonuses: 4,
  BuyPromoSpin: 5,
  CasinoJackpot: 6,
  CasinoTax: 7,
  Deposit: 8,
  Withdrawal: 10,
  PendingWithdrawal: 11,
};

const noteTypes = {
  Risk: 1,
  Marketing: 2,
  Complaint: 3,
  Casino: 4,
  Sport: 5,
  Other: 6,
  Security: 7,
  Migration: 8,
  Payment: 9,
};

const gameRiskTypes = {
  Cashback: 1,
  FreeBet: 2,
  Wager: 3,
  Promotions: 4,
  Tournament: 5,
};

const episPlayerStates = {
  Registered: 2,
  Validated: 3,
};

const performedByTypes = _.pick(exclusionPerformedByTypes, ['Admin', 'Player']);

const gameGroupTypes = {
  System: 1,
  Custom: 2,
  ZingBrain: 3,
  BiRecommendation: 4,
};

const jackpotTypes = {
  Amusnet: 1,
  Relum: 2,
};

const crossPlatformCampaignV2SourceTypes = {
  Smartico: 1,
  Gamification: 2,
  // PushNotification: 3,
  CRM: 4,
  // Betera: 5,
  // Thunderbyte: 6,
  Campaign: 7,
  Cashback: 8,
  SportsBook: 9,
  RGS: 10,
};

const campaignV2UnitAllocationTypes = {
  OneUnit: 1,
  AllUnits: 2,
};

const limitStatus = {
  Active: 1,
  Inactive: 2,
  Pending: 3,
};

const limitLevel = {
  Current: 1,
  Operator: 2,
  Pending: 3,
};

const googleAdsConversionEventType = {
  Registration: 1,
  FTD: 2,
  Deposit: 3,
};

// TODO: Remove after templates moved to RTK
const notificationProductTypes = {
  Sport: 1,
  Casino: 2,
  Other: 3,
};

const depositTypes = {
  All: 0,
  Deposit: 1,
  AutoDeposit: 2,
};

const enumTypes = {
  channels,
  messageCategories,
  playerStatuses,
  templateStatus,
  massMessageStatuses,
  notificationPreferences,
  notificationTypes,
  domainStatuses,
  genders,
  bonuses,
  bonusStatuses,
  playerBonusStatuses,
  marketingStatuses,
  periods,
  promoCodeTypes,
  markAttentionLevels,
  playerActions,
  walletType,
  providerSpecificType,
  playerVerification,
  cashBackType,
  cashbackTransferType,
  captchaType,
  brandStatuses,
  cashBackReferralPeriodStatus,
  allBonusTypes,
  testPlayerAccountType,
  similarAccountDetectionArea,
  similarAccountParameterType,
  referralFinancialActivity,
  referralReferees,
  referralBonusType,
  referralBonusAmount,
  referralActivities,
  selfExclusionPeriods,
  playerReasons,
  timeoutPeriod,
  limitPeriod,
  limitationTypes,
  sportBonusBetType,
  expressOddType,
  requestMethods,
  paymentRequestStatuses,
  betStates,
  largeTransactionTypes,
  playerLimitPeriodTypes,
  playerLimitsPeriods,
  paymentTransactionTypes,
  playerPaymentRelations,
  legalAgreementVersionStatuses,
  brandAutomationOperator,
  brandVerificationDocumentTypes,
  paymentType,
  processingTypes,
  paymentActivities,
  paymentMethodsFeesTypes,
  paymentMethodLimitTypes,
  paymentMethodActionTypes,
  paymentProcessingOption,
  paymentProcessingRangeUnit,
  cashierOtherId,
  cashierPaymentSettings,
  bonusCommonStatuses,
  cashbackCalculationFrom,
  cashbackParticipateRules,
  tagNoCategoryId,
  allDeviceTypes,
  deviceTypes,
  selectedPlayersErrorStatus,
  quickSearchResponseItemType,
  walletTransactionTypes,
  lobbyWidgetGridTypes,
  betTypes,
  logicTypes,
  gameOrderTypes,
  playerContactInfoVerificationTypes,
  playerPhysicalVerificationTypes,
  sportPlayerStatus,
  brandAutomationConditionPeriodType,
  boolean,
  sessionEndReason,
  resource,
  reasonsType,
  bonusCountTypes,
  campaignTriggerPeriodTypes,
  campaignTriggerOption,
  campaignTriggerTypes,
  campaignParticipantTypes,
  campaignConditionTypes,
  weekDays,
  campaignOperators,
  politicallyExposedPerson,
  tagCategoryType,
  playerBlockedStatuses,
  sportsBookMobileIntegrationType,
  sportsBookLayoutTypes,
  realityCheckRepetitionPeriod,
  affiliateTypes,
  analyticTypes,
  liveChatSolutionTypes,
  crmTypes,
  retailSolutionTypes,
  userClaimTypes,
  campaignUseTypes,
  lobbyGridTypes,
  lobbyFilterTypes,
  lobbyViewTypes,
  lobbyProvidersPositions,
  lobbyGamesViewTypes,
  lobbyGameDetailsOnHoverTypes,
  maxExpressOddTypes,
  brandVerificationPeriod,
  promotionalItemType,
  promotionalItemStatus,
  rgsDeviceIds,
  exportReportStates,
  bonusCancellerTypes,
  bonusActivationTypes,
  devToolDbSyncMergeModes,
  pushNotificationRecipients,
  pushNotificationStatuses,
  playerPushNotificationStatuses,
  permissionSecurityLevel,
  campaignSourceTypes,
  deepLinkSections,
  playerAccessLimitTypes,
  inactivityTriggerTypes,
  inactivePeriodMonths,
  failedBonusReasons,
  tagAction,
  gamesMobileLaunchTypes,
  freeGameWinType,
  inactivePlayerMoneyTransferTypes,
  inactivePlayerCredentialsProvidedTypes,
  releaseNoteLabels,
  systemPartnerId,
  gamificationTypes,
  authenticationTypes,
  crossCampaignSourceTypes,
  crossCampaignSourceStatuses,
  lobbyProvidersViewTypes,
  lobbyGroupsViewTypes,
  thirdPartyServicesStatuses,
  jackpotFeedTypes,
  campaignV2ParticipantTypes,
  campaignV2ParticipantConditionTypes,
  campaignV2TriggerConditionTypes,
  campaignV2RecurringTriggerConditionTypes,
  campaignV2Operators,
  campaignV2TriggerTypes,
  campaignV2PromoCodeTypes,
  campaignV2Statuses,
  campaignV2UseTypes,
  campaignV2BonusFamilies,
  campaignV2Bonuses,
  campaignV2GameTypes,
  campaignV2RgsDeviceIds,
  campaignV2SportBonusBetTypes,
  campaignV2WageringAmountTypes,
  campaignV2WageringParticipationTypes,
  campaignV2FirstDebitedWalletTypes,
  campaignV2LockAmountTypes,
  campaignV2TriggerOptions,
  campaignV2TriggerOptionPeriods,
  massMessageSourceTypes,
  campaignV2BonusCancellerTypes,
  playerBlockActions,
  campaignV2FreeSpinWinTypes,
  jackpotSetStatuses,
  widgetGameSelectionTypes,
  campaignV2BetContributionTypes,
  regulatoryExclusionTypes,
  regulatoryExclusionChannels,
  regulatoryExclusionDurationCategories,
  campaignV2MixedBonusSubTypes,
  cashbackV2CalculationFrom,
  sportTreeRuleInvolvements,
  cashbackV2WinTypes,
  cashbackV2PrizeTypes,
  campaignV2SourceTypes,
  regulatoryBetEventCategoriesA,
  betWalletTypes,
  websiteWalletTypes,
  regulatoryPlayerLimitCategories,
  regulatoryGameCategories,
  regulatoryBetEventTypes,
  regulatoryBonusCategoryA,
  regulatoryBonusCategoryB,
  playersBettingAggregationCriteriaTypes,
  bettingEventCategories,
  bettingPerformanceBetTypes,
  taxationTypes,
  taxationProductCategories,
  campaignV2SportEventTypes,
  lobbyWidgetDeviceTypes,
  campaignV2EligibleBetTypes,
  campaignV2EligibleBetStates,
  realityCheckCalculationTypes,
  aggregationCriteriaTypes,
  campaignV2SportBetBuilderTypes,
  campaignV2UnitStatuses,
  legalAgreementStates,
  blockCountryTypes,
  eddVerificationOptions,
  selectionTypes,
  digitainAffiliateDataSendPeriodTypes,
  lobbyDemoButtonOnGamesDeviceTypes,
  exportTypes,
  cashbackV2ParticipateRules,
  liabilityWalletTypes,
  liabilityTypes,
  referralParticipationTypes,
  providerActionTypes,
  transactionsHistoryTypes,
  noteTypes,
  exclusionPerformedByTypes,
  timeLimitPerformedByTypes,
  gameRiskTypes,
  episPlayerStates,
  performedByTypes,
  gameGroupTypes,
  jackpotTypes,
  crossPlatformCampaignV2SourceTypes,
  campaignV2UnitAllocationTypes,
  limitStatus,
  limitLevel,
  googleAdsConversionEventType,
  notificationProductTypes,
  depositTypes,
};

export default enumTypes;
